import React, { Component } from "react";
import { connect } from "react-redux";
import CartOptions from "../../Cart/CartOptions";
import moment from "moment";
import { SwipeableDrawer, Drawer } from "@material-ui/core";
import DrawerContent from "./DrawerContent";
import dairyFreeIcon from "../../ActionButton/assests/no-milk.png";
import glutenFreeIcon from "../../ActionButton/assests/gluten-free.png";
import sugarFreeIcon from "../../ActionButton/assests/sugar-free.png";
import nutFreeIcon from "../../ActionButton/assests/peanut-free.png";
import organicIcon from "../../ActionButton/assests/bio_480.png";
import vegetarianIcon from "../../ActionButton/assests/leaf.png";
import veganIcon from "../../ActionButton/assests/vegan.png";
import glutenIcon from "../../ActionButton/assests/gluten.png";
import nutsSesameIcon from "../../ActionButton/assests/nuts_sesame.png";
import dairyIcon from "../../ActionButton/assests/dairy.png";
import eggIcon from "../../ActionButton/assests/egg.png";
import seafoodShellfishIcon from "../../ActionButton/assests/seafood_shellfish.png";
import chilliIcon from "../../ActionButton/assests/chilli.png";
import { getCurrencyIcon } from "../../../Helpers/currencyConverter";
class CartItem extends Component {
  ar_days = {
    Sun: "اﻷحد",
    Mon: "اﻷثنين",
    Tue: "الثلاثاء",
    Wed: "اﻷربعاء",
    Thu: "الخميس",
    Fri: "الجمعة",
    Sat: "السبت",
  };
  ar_months = {
    Jan: "يناير ",
    Feb: "فبراير",
    Mar: "مارس",
    Apr: "أبريل",
    May: "مايو",
    Jun: "يونيو",
    Jul: "يوليو",
    Aug: "أغسطس",
    Sept: "سبتمبر",
    Sep: "سبتمبر",
    Oct: "أكتوبر",
    Nov: "نوفمبر",
    Dec: "ديسمبر",
  };
  state = {
    drawerOpen: false,
  };
  toggleDrawer = (open) => {
    this.setState({ drawerOpen: open });
  };
  getBooking = () => {
    let booking = this.props.originalProduct.booking_slots.find(
      (booking) => booking.id === this.props.product.booking_slot
    );
    if (!booking) return null;

    let [year, month, day] = booking.booking_date.split("-");
    let date = new Date(year, month - 1, day);
    date = date.toString().split(" ");

    let day_numb = parseInt(date[2], 10);
    day = this.props.language === "english" ? date[0] : this.ar_days[date[0]];
    month =
      this.props.language === "english" ? date[1] : this.ar_months[date[1]];

    let formattedDate;

    if (!booking.all_day) {
      formattedDate = `${day} ${day_numb} ${month} - ${booking.start.slice(
        booking.start[0] === "0" ? 1 : 0,
        5
      )}`;

      if (this.props.settings.show_booking_end_slot) {
        formattedDate += ` ${
          this.props.language === "arabic" ? "حتى" : "to"
        } ${booking.end.slice(booking.end[0] === "0" ? 1 : 0, 5)}`;
      }
    } else {
      formattedDate = `${day} ${day_numb} ${month} - ${
        this.props.language === "arabic" ? "البوم باكمله" : "Whole Day"
      }`;
    }

    return <span>{formattedDate}</span>;
  };

  translateSlotText = (text) => {
    const { language } = this.props;
    if (language == "english") return text;

    let temp = text.replace(/PM/g, "م");
    temp = temp.replace(/AM/g, "ص");
    return temp;
  };

  translateDate = (date) => {
    const { language } = this.props;
    if (language == "english") return date;

    const ar_months = {
      January: "يناير ",
      February: "فبراير",
      March: "مارس",
      April: "أبريل",
      May: "مايو",
      June: "يونيو",
      July: "يوليو",
      August: "أغسطس",
      September: "سبتمبر",
      October: "أكتوبر",
      November: "نوفمبر",
      December: "ديسمبر",
    };
    let temp = date;
    Object.keys(ar_months).forEach((month) => {
      temp = temp.replace(month, ar_months[month]);
    });
    return temp;
  };

  getServiceDetails = (product) => {
    const { language } = this.props;
    let [date, start, end] = product.resourceSlot.split(" ");

    date = moment(date, "YYYY-MM-DD").format("LL");
    start = moment(start, "HH:mm:ss").format("h:mm A");
    end = moment(end, "HH:mm:ss").format("h:mm A");

    return (
      <>
        <p className="mb-0">
          {language == "english" ? "With" : "مع"}:{" "}
          {language == "english"
            ? product.resource.name
            : product.resource.ar_name || product.resource.name}
        </p>
        <p className="mb-0">
          {language == "english" ? "Date" : "التاريخ"}:{" "}
          {this.translateDate(date)}
        </p>
        <p className="mb-0">
          {language == "english" ? "Time" : "الوقت"}:{" "}
          {this.translateSlotText(`${start} - ${end}`)}
        </p>
        <p>
          {language == "english" ? "Branch" : "فرع"}:{" "}
          {language == "english"
            ? product.resource.branch.name
            : product.resource.branch.ar_name || product.resource.branch.name}
        </p>
      </>
    );
  };

  getPreordredDetails = (product, publishedIntheFuture) => {
    let earliestDeliveryDate;
    if (publishedIntheFuture) {
      earliestDeliveryDate = moment(product.publishedDate);
    } else {
      earliestDeliveryDate = moment().add(
        product.preordering_leadtime,
        "hours"
      );
    }
    const { language } = this.props;
    if (language == "arabic") {
      const month = this.ar_months[earliestDeliveryDate.format("MMM")];
      const day = earliestDeliveryDate.format("DD");
      const year = earliestDeliveryDate.format("YYYY");
      const time = earliestDeliveryDate.format("HH:MM");
      return `مضاف كطلب مسبق ليتمم لاحقا. أقرب وقت للتوصيل ${day}-${month}-${year} ${time}`;
    } else {
      return `Item is preordred, earliest delivery date: ${earliestDeliveryDate.format(
        "DD-MMM-YYYY HH:MM"
      )}`;
    }
  };
  render() {
    const { language, settings, product } = this.props;

    const publishedIntheFuture =
      product.publishedDate && moment(product.publishedDate).isAfter(moment());

    const isDiscounted =
      product.total_price * product.quantity +
        product.quantityExcludedOptionsTotal >
        this.props.priceAfterDiscount && !product.promo;
    const currencyIcon = getCurrencyIcon(settings)
    return (
      <div
        className="row"
        style={{
          cursor: "pointer",
        }}
      >
        <Drawer
          anchor="bottom"
          open={this.state.drawerOpen}
          onClose={() => this.toggleDrawer(false)}
          PaperProps={{
            style: { minHeight: 100, height: "auto", width: "100%" },
            className: "text-center",
          }}
          onBackdropClick={() => this.toggleDrawer(false)}
        >
          <DrawerContent
            itemProps={this.props}
            closeModal={() => this.setState({ drawerOpen: false })}
            calculateNutritions={() => this.props.calculateNutritions()}
          />
        </Drawer>
        <div
          className="col-2 my-2"
          style={{
            color: this.props.themeColor ? this.props.themeColor : "#0099cc",
          }}
        >
          {`${this.props.quantity}x`}
        </div>
        <div
          className={"col-7 my-2 ".concat(
            language == "english" ? "text-left" : "text-right"
          )}
          //style={{ fontWeight: 300 }}
          onClick={() => this.toggleDrawer(true, "hi")}
        >
          <span>
            {this.props.name}
            {this.props.product.booking_slot &&
              this.props.originalProduct.type_of_product == "bookable" && (
                <small>
                  <br />
                  {this.getBooking()}
                </small>
              )}
            {/* {(this.props.product.is_preordered || publishedIntheFuture) && (
              <small style={{ color: "red" }}>
                <br />
                {this.getPreordredDetails(
                  this.props.product,
                  publishedIntheFuture
                )}
              </small>
            )} */}
            {this.props.originalProduct.type_of_product == "service" && (
              <small>
                <br />
                {this.getServiceDetails(this.props.product)}
              </small>
            )}
          </span>
          <CartOptions
            checkout
            product={this.props.product}
            originalProduct={this.props.originalProduct}
          />
          {settings.show_nutrition_facts && (
            <div
              className="ml-3"
              style={{
                textAlign: this.props.language === "arabic" ? "right" : "left",
              }}
            >
              {this.props.dietaryRestrictions?.isDairyFree && (
                <img
                  src={dairyFreeIcon}
                  style={{ marginRight: 5, height: 17, width: 17 }}
                />
              )}
              {this.props.dietaryRestrictions?.isGlutenFree && (
                <img
                  src={glutenFreeIcon}
                  style={{ marginRight: 5, height: 17, width: 17 }}
                />
              )}
              {this.props.dietaryRestrictions?.isSugarFree && (
                <img
                  src={sugarFreeIcon}
                  style={{ marginRight: 5, height: 17, width: 17 }}
                />
              )}
              {this.props.dietaryRestrictions?.isNutFree && (
                <img
                  src={nutFreeIcon}
                  style={{ marginRight: 5, height: 17, width: 17 }}
                />
              )}
              {this.props.dietaryRestrictions?.isVegan && (
                <img
                  src={veganIcon}
                  style={{ marginRight: 5, height: 17, width: 17 }}
                />
              )}
              {this.props.dietaryRestrictions?.isVegetarian && (
                <img
                  src={vegetarianIcon}
                  style={{ marginRight: 5, height: 17, width: 17 }}
                />
              )}
              {this.props.dietaryRestrictions?.isOrganic && (
                <img
                  src={organicIcon}
                  style={{ marginRight: 5, height: 17, width: 17 }}
                />
              )}
              {this.props.dietaryRestrictions?.containsGluten && (
                <img
                  src={glutenIcon}
                  alt="Gluten"
                  style={{ marginRight: 5, height: 17, width: 17 }}
                />
              )}

              {this.props.dietaryRestrictions?.containsNutsSesame && (
                <img
                  src={nutsSesameIcon}
                  alt="Nuts/Sesame"
                  style={{ marginRight: 5, height: 17, width: 17 }}
                />
              )}

              {this.props.dietaryRestrictions?.containsDairy && (
                <img
                  src={dairyIcon}
                  alt="Dairy"
                  style={{ marginRight: 5, height: 17, width: 17 }}
                />
              )}

              {this.props.dietaryRestrictions?.containsEgg && (
                <img
                  src={eggIcon}
                  alt="Egg"
                  style={{ marginRight: 5, height: 17, width: 17 }}
                />
              )}

              {this.props.dietaryRestrictions?.containsSeafoodShellfish && (
                <img
                  src={seafoodShellfishIcon}
                  alt="Seafood/Shellfish"
                  style={{ marginRight: 5, height: 17, width: 17 }}
                />
              )}

              {this.props.dietaryRestrictions?.containsChilli && (
                <img
                  src={chilliIcon}
                  alt="Chilli"
                  style={{ marginRight: 5, height: 17, width: 17 }}
                />
              )}
            </div>
          )}
        </div>

        <div
          className={"col-1 my-2 p-0 "
            .concat(language == "english" ? "text-left" : "text-right")
            .concat(` ${currencyIcon}`)}
          dir={language == "english" ? "rtl" : "ltr"}
          //style={{ fontWeight: 300 }}
        >
          {`${(product.promo
            ? product.total_price * product.quantity +
              product.quantityExcludedOptionsTotal
            : this.props.priceAfterDiscount
          ).toFixed(settings.currency_decimals)}`}
        </div>
        <div
          className={"col-1 my-2 p-0 ".concat(
            language == "english" ? "text-right" : "text-left"
          )}
        >
          {language == "english"
            ? settings.currency_english
            : settings.currency_local}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    language: state.store.language,
    themeColor: state.store.store.settings.dark,
    settings: state.store.store.settings,
  };
};

export default connect(mapStateToProps)(CartItem);
